
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 31.08 20.71"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 0h31.07v20.71H0z"}}),_c('path',{attrs:{"fill":"#102a93","d":"M0 0h10.36v20.71H0z"}}),_c('path',{attrs:{"fill":"#e22a3d","d":"M20.72 0h10.36v20.71H20.72z"}})])
          )
        }
      }
    